<template>
  <div>
    <h4>Basic Setting</h4>
    <el-card>
      <el-form-item label="Due date">
        <el-date-picker
          v-model="date"
          type="date"
          format="dd MMM yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Choose Date"
          size="mini"
        ></el-date-picker>
        <span class="note">As of that date selected here , which goods of slow-moving have reached the set standard of unsold days.</span>
      </el-form-item>
      <el-form-item label="Unsolde days">
        <el-input type="number" v-model="unsold" :style="{ width: '200px' }" size="mini" placeholder="Enter number"></el-input>
        <span class="note">This value indicates that no sales have occurred during this time.</span>
      </el-form-item>
      <el-form-item label="Qty Criterion">
        <el-input type="number" v-model="qty" :style="{ width: '200px' }" size="mini" placeholder="Enter number"></el-input>
        <span class="note">The sales of products which below this value will be counted.</span>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ReportBasicSettingSl',
  created () {},
  props: {
  },
  computed: {
    ...mapState('report', ['dueDate', 'unSold', 'qtyCriterion']),
    date: {
      get () {
        return this.dueDate
      },
      set (val) {
        this.setDueDate(val)
      }
    },
    unsold: {
      get () {
        return this.unSold
      },
      set (val) {
        this.setUnsold(val)
      }
    },
    qty: {
      get () {
        return this.qtyCriterion
      },
      set (val) {
        this.setQty(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setDueDate: 'report/setDueDate',
      setUnsold: 'report/setUnsold',
      setQty: 'report/setQtyCriterion'
    })
  }
}
</script>

<style lang="scss" scoped>
.note {
  margin-left: 12px;
  font-size: 12px;
  color: #9b9b9b
}
</style>
